const PROFILE_KEY = "vk_driver_profile";
const CONSENT_KEY = "vk_cookie_consent";
const PROFILE_DAYS = 365;
const CONSENT_DAYS = 365;

function setCookie(name, value, days) {
    const expires = new Date();
    expires.setDate(expires.getDate() + days);
    document.cookie = [
        `${name}=${encodeURIComponent(JSON.stringify(value))}`,
        `expires=${expires.toUTCString()}`,
        "path=/",
        "SameSite=Lax",
    ].join("; ");
}

function getCookie(name) {
    const match = document.cookie
        .split("; ")
        .find(row => row.startsWith(`${name}=`));
    if (!match) return null;
    try {
        return JSON.parse(decodeURIComponent(match.split("=").slice(1).join("=")));
    } catch {
        return null;
    }
}

function deleteCookie(name) {
    document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; SameSite=Lax`;
}

export function getConsent() {
    return getCookie(CONSENT_KEY);
}

export function acceptConsent() {
    setCookie(CONSENT_KEY, { accepted: true, timestamp: new Date().toISOString() }, CONSENT_DAYS);
}

export function declineConsent() {
    setCookie(CONSENT_KEY, { accepted: false, timestamp: new Date().toISOString() }, CONSENT_DAYS);
}

export function hasAcceptedConsent() {
    const c = getConsent();
    return c !== null && c.accepted === true;
}

export function hasDecidedConsent() {
    return getConsent() !== null;
}

export function getDriverProfile() {
    return getCookie(PROFILE_KEY);
}

export function saveDriverProfile(data) {
    if (!hasAcceptedConsent()) return;
    const existing = getDriverProfile() || {};
    setCookie(PROFILE_KEY, { ...existing, ...data }, PROFILE_DAYS);
}

export function saveAvatarConfig(avatar) {
    if (!hasAcceptedConsent()) return;
    const existing = getDriverProfile() || {};
    setCookie(PROFILE_KEY, { ...existing, avatar }, PROFILE_DAYS);
}

export function clearDriverProfile() {
    deleteCookie(PROFILE_KEY);
}

export function isRegisteredInCookie() {
    const p = getDriverProfile();
    return p !== null && p.registered === true;
}

// Consent bypass — safe to call after verify (user provably accepted before registering)
export function saveDriverProfileForced(data) {
    const existing = getCookie(PROFILE_KEY) || {};
    setCookie(PROFILE_KEY, { ...existing, ...data }, PROFILE_DAYS);
}